import { createSlice } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const mobileMenuSlice = createSlice({
  name: 'mobileMenu',
  initialState: {
    isMobileMenuOpen: false,
    isSidebarCollapsed: true,
  },
  reducers: {
    setMobileMenuOpen: (state, action) => {
      state.isMobileMenuOpen = action.payload;
    },
    toggleMobileMenu: (state, action) => {
      state.isMobileMenuOpen =!state.isMobileMenuOpen;
    },
    setSidebarCollapsed: (state, action) => {
      state.isSidebarCollapsed = action.payload;
    },
    toggleSidebar: (state, action) => {
      state.isSidebarCollapsed =!state.isSidebarCollapsed;
    }
  },
});

export const {
  setMobileMenuOpen,
  toggleMobileMenu,
  setSidebarCollapsed,
  toggleSidebar
} = mobileMenuSlice.actions;

export const useMobileMenuState = () => useSelector(state => state.mobileMenu);
export const useMobileMenuActions = () => {
  const dispatch = useDispatch();
  return useMemo(() => ({
    setMobileMenuOpen: (isOpen) => dispatch(setMobileMenuOpen(isOpen)),
    toggleMobileMenu: () => dispatch(toggleMobileMenu()),
    setSidebarCollapsed: (isCollapsed) => dispatch(setSidebarCollapsed(isCollapsed)),
    toggleSidebar: () => dispatch(toggleSidebar()),
  }), [dispatch]);
}

export default mobileMenuSlice.reducer;
